<template>
  <nav class="navbar navbar-default" style="height:100px;">
    <div class="container" style="padding:0px;">
      <div class="col-xs-12 navbar-header">
        <div class="col-xs-8" style="padding:0px;">
          <h2 style="padding-left:15px;margin-top:30px;" class="titleSize">
            <strong>{{ title }} ({{ mName }})</strong>
          </h2>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
// import JS from './JsonService'
export default {
  data() {
    return {
      title: 'e-Ordering',
      mName: ''
    }
  },
  created: function() {
    // var domainName = window.location.hostname
    // console.log('domainName:', domainName)
    // if (domainName == 'localhost' || domainName == '192.168.0.150') {
    //   // domainName = 'eorder.postchat.us'
    //   // domainName = 'senjutei.mpos.us'
    //   domainName = 'demo.mpos.us'
    // }
    // const url = 'Order/GetInitList'
    // const parameter = {
    //   av: '1',
    //   ko: domainName
    // }
    // JS.request(url, parameter)
    //   .then(response => {
    //     // console.log(response.data)
    //     if (response.data == '@#=#@@=$#43@=$#Merchant Not Found@=$#0') {
    //       this.$router.replace('**')
    //     } else {
    //       this.getListOfMchtInfo(response.data)
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    // getListOfMchtInfo(data) {
    //   this.ListOfMchtInfo = []
    //   const ListOfMchtInfo = data.ListOfMchtInfo
    //   for (let i = 0; i < ListOfMchtInfo.length; i++) {
    //     this.ListOfMchtInfo.push(ListOfMchtInfo[i])
    //     this.mName = this.ListOfMchtInfo[i].ez
    //   }
    // }
  }
}
</script>

<style>
.eMsg {
  margin: var(--header-eMsg-margin);
  margin-top: var(--header-eMsg-margin_top);
  color: var(--header-eMsg-color);
  font-size: var(--header-eMsg-font_size);
}

h2 {
  text-align: var(--header-h2-text_align);
  font-size: var(--header-h2-font_size);
}

.col-md-6 {
  background-color: var(--header-col_md_6-background_color);
  border-radius: var(--header-col_md_6-border_radius);
}

.titleSize {
  margin-top: 10px;
  font-size: 30px;
}

@media (max-width: 590px) {
  .titleSize {
    font-size: 20px;
  }
}

@media (max-width: 550px) {
  button.btn {
    padding-left: var(--header-mediaMax550-button_btn-padding_left);
    padding-right: var(--header-mediaMax550-button_btn-padding_right);
  }

  .eMsg {
    margin: var(--header-mediaMax550-eMsg-margin);
    margin-top: var(--header-mediaMax550-eMsg-margin_top);
    color: var(--header-mediaMax550-eMsg-color);
    font-size: var(--header-mediaMax550-eMsg-font_size);
    margin-left: var(--header-mediaMax550-eMsg-margin_left);
    margin-right: var(--header-mediaMax550-eMsg-margin_right);
  }
}

@media (max-width: 400px) {
  .titleSize {
    font-size: 15px;
  }

  h3 {
    font-size: 20px;
  }
}

@media (max-width: 310px) {
  .titleSize {
    font-size: 13px;
  }
}
</style>
